import { jsx as _jsx } from "react/jsx-runtime";
import { TableBodyRowEmpty } from './TableBodyRowEmpty';
import { TableBodyRowWithData } from './TableBodyRowWithData';
export function TableBodyRow({ columns, row, virtualRow }) {
    if (!row) {
        return _jsx(TableBodyRowEmpty, { index: virtualRow.index, columns: columns }, `row-item-${virtualRow.index}-empty`);
    }
    return _jsx(TableBodyRowWithData, { index: virtualRow.index, row: row, columns: columns }, `row-item-${row.id}`);
}
//# sourceMappingURL=TableBodyRow.js.map